module.exports = __webpack_public_path__ + "img/icon_mailbox.f52adf21.png";